import React from "react";
import { cn } from "@/lib/utils";

const FLOW = [
  { key: "New", label: "New" },
  { key: "Preparing", label: "Prep" },
  { key: "Ready", label: "Ready" },
  { key: "Served", label: "Served" },
];

export default function KotStatusStepper({ status, statusFlow }) {
  const normalized = status === "Completed" ? "Served" : status;
  const steps = statusFlow?.length
    ? statusFlow.map((s) => ({ key: s.status, label: FLOW.find((f) => f.key === s.status)?.label || s.status, reached: s.reached }))
    : FLOW.map((step) => ({
        key: step.key,
        label: step.label,
        reached: FLOW.findIndex((f) => f.key === step.key) <= FLOW.findIndex((f) => f.key === normalized),
      }));

  const currentIndex = steps.findIndex((s) => s.key === normalized);

  return (
    <div className="flex items-center gap-1 px-3.5 py-2 border-b bg-slate-50/60">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <div
            className={cn(
              "text-[9px] font-bold uppercase px-1.5 py-0.5 rounded whitespace-nowrap",
              step.reached && index < currentIndex && "bg-emerald-100 text-emerald-700",
              index === currentIndex && "bg-slate-900 text-white shadow-sm",
              !step.reached && index > currentIndex && "bg-slate-100 text-slate-400",
              step.reached && index === currentIndex && "bg-slate-900 text-white",
            )}
          >
            {step.label}
          </div>
          {index < steps.length - 1 && (
            <div
              className={cn(
                "h-0.5 flex-1 min-w-[8px] rounded-full",
                index < currentIndex ? "bg-emerald-300" : "bg-slate-200",
              )}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
